import { render, staticRenderFns } from "./Seccion.vue?vue&type=template&id=29d59370&"
import script from "./Seccion.vue?vue&type=script&lang=js&"
export * from "./Seccion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports